module.exports = __webpack_public_path__ + "static/media/hello-world.03210864.md";